/**
 * @generated SignedSource<<2d80440392fbc1a8dc71584d6ecd98b2>>
 * @relayHash a880580d17ea37c1ecf818a2e8b64373
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 272a4ac907ee41981af68e0c4a9bc140b3018d431ffc6ce53d40294d2a147114

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiVersionDetailsQuery } from './uiVersionDetailsQuery.graphql';

const node: PreloadableConcreteRequest<uiVersionDetailsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "272a4ac907ee41981af68e0c4a9bc140b3018d431ffc6ce53d40294d2a147114",
    "metadata": {},
    "name": "uiVersionDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
